<template>
  <!--<div id="app" v-touch:right="onSwipeRight">-->
      <!--<transition>-->
        <!--<router-view></router-view>-->
      <!--</transition>-->
  <!--</div>-->
  <div id="app" >
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    methods: {
      onSwipeRight () {
        this.$router.go(-1)
      }
    },
      created(){
        if(!this.$store.state.token && localStorage.getItem('token')){
            this.$store.dispatch('setToken', localStorage.getItem('token'))
        }
      }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
#app
  text-align: center
</style>



// WEBPACK FOOTER //
// App.vue?7fca9da8